(function (app) {
  $(document).ready(function () {

    app.UserView = function () {

      var _this = this;
      var nameSpace = 'UserView',
        context = '.page__user-settings--container'
        ;

      _this.validatePassword = function () {
        var passwordInformationForm = $('form[name="user__edit"]');

        var fields = {
          'password': $('input[name="password"]', passwordInformationForm),
          'confirm_password': $('input[name="confirm_password"]', passwordInformationForm),
        };

        var values = {
          password: $.trim(fields.password.val()),
          confirm_password: $.trim(fields.confirm_password.val())
        };

        var errors = [];

        $.each(fields, function () {
          $(this).closest('.form-group').removeClass('has-error');
        });

        if (values.password != values.confirm_password) {
          fields.confirm_password.closest('.form-group').addClass('has-error');
          errors.push('Passwords do not match');
        }

        if (_.size(errors)) {
          alertify.error(errors.join('<br>'));
          return false;
        }
        return true;
      };

      return {
        init: function () {
          $(document).off('submit.user_update__' + nameSpace).on('submit.user_update__' + nameSpace, context + ' form[name="user__edit"]', function (e) {
            var $form = $('form[name="user__edit"]');
            var $submitButton = $('button[type=submit]', $form);
            var appTransport = app.transport();
            var requestData = $form.serializeObject();
            var id = parseInt($.trim(requestData.id));

            if (_.isEmpty($.trim(requestData.email))) {
              app.flashMessenger('error', 'Email is required');
              return e.preventDefault();
            }

            if (_.isEmpty($.trim(requestData.timezone))) {
              app.flashMessenger('error', 'Timezone is required');
              return e.preventDefault();
            }

            if (_this.validatePassword() == false)  return e.preventDefault();

            delete requestData.confirm_password;

            $submitButton.button('loading');
            appTransport
              .setEvent('onSuccess', function (response) {
                if (response.id) {
                  if (id) {
                    app.flashMessenger('success', 'User Updated Successfully');
                  } else {
                    app.flashMessenger('success', 'User Saved Successfully');
                  }
                } else {
                  app.flashMessenger('error', 'Error saving user');
                }

              })
              .setEvent('onError', function (error) {
                app.flashMessenger('error', error.code + '::' + error.message.message);
              })
              .setEvent('onComplete', function () {
                $submitButton.button('reset');
              })
            ;

            if (id) {
              appTransport.put('/api/user/' + requestData.id, requestData);
            } else {
              appTransport.post('/api/user', requestData);
            }

            return e.preventDefault();

          });
        }
      }

    }

  });

})(PreBuilt);

